import React from 'react';
import ReactDOM from 'react-dom';

import { App } from 'cd-eft';
import { AppVM } from 'cd-eft/components/app/appVM';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { DiagnosticView } from 'cd-eft/components/diagnostic/DiagnosticView';
// import reportWebVitals from "./reportWebVitals";



const appVm = new AppVM();
appVm.initializeModel();

ReactDOM.render(
  // <React.StrictMode>
  //   <App />
  // </React.StrictMode>,

  // <App appVm={appVm} />,

  <BrowserRouter
    getUserConfirmation={() => {
      /* Empty callback to block the default browser prompt */
    }}
  >
    <Switch>
      <Route path="/diagnostic">
        <DiagnosticView />
      </Route>
      <Route path="/">
        <App appVm={appVm} />
      </Route>
    </Switch>
  </BrowserRouter>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
